import { Button, message } from "antd"
import { SyncOutlined } from "@ant-design/icons"
import { useState } from "react"
import apiClient from "../../Utils/apiClient"
import { isBlankGeo } from "../../Utils/deviceGeo"

const FetchIpLocationButton = ({
  device,
  fields = ["ip", "location"],
  onUpdated,
}) => {
  const [loading, setLoading] = useState(false)
  const needsFetch =
    Boolean(device?._id) &&
    fields.some((field) => isBlankGeo(device?.[field]))

  if (!needsFetch) return null

  const handleFetch = async (event) => {
    event?.stopPropagation?.()
    setLoading(true)
    try {
      const res = await apiClient(
        `devices/${device._id}/fetch-ip-location`,
        "POST"
      )
      if (res?.success) {
        message.success("Updated IP and location")
        onUpdated?.({
          _id: device._id,
          ip: res.ip,
          location: res.location,
        })
      } else {
        message.warning(res?.message || "Could not fetch IP and location")
      }
    } catch (err) {
      message.error(err.message || "Could not fetch IP and location")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      type="link"
      size="small"
      className="fetch-geo-btn"
      icon={<SyncOutlined />}
      loading={loading}
      onClick={handleFetch}
    >
      Fetch
    </Button>
  )
}

export default FetchIpLocationButton
